import React, { DispatchWithoutAction, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
	CheckoutOrderFragment,
	GdsServicesWithPurchasePredictions_OrderAdditionalServiceGdsServiceMeal_Fragment
} from '@websky/graphql';
import { getDurationInSeconds } from '../../../Results/utils';
import UpsaleItem from '@features/upsale/ui/UpsaleItem/UpsaleItem';
import AiPredictionFooter from '../AiPredictionFooter/AiPredictionFooter';

interface Props {
	order: CheckoutOrderFragment;
	meal: GdsServicesWithPurchasePredictions_OrderAdditionalServiceGdsServiceMeal_Fragment;
	onAgree: DispatchWithoutAction;
	onChange: DispatchWithoutAction;
	onDisagree: DispatchWithoutAction;
}

const AiPurchasePredictionMeal: React.FC<Props> = ({ order, meal, onChange, onDisagree, onAgree }) => {
	const { t } = useTranslation('AIPurchasePredictionService');

	const time = useMemo(() => {
		let maxDurationInMinutes = 0;

		order.flight.segments.forEach(segment => {
			const inSeconds = getDurationInSeconds(segment.segment.duration);

			const inMinutes = inSeconds / 60;

			if (inMinutes > maxDurationInMinutes) {
				maxDurationInMinutes = inMinutes;
			}
		});

		return Math.floor(maxDurationInMinutes / 60);
	}, [order]);

	const headerTitle =
		time > 0
			? t('YourFlightHours', { hours: time, plural: t('hours', { count: time }) })
			: t('Order your meals in advance');

	const service = useMemo(() => ({
		price: meal.price,
		name: meal.description,
		header: <img src={meal.image} alt={meal.name} />
	}), [meal]);

	return (
		<>
			<UpsaleItem
				title={headerTitle}
				service={service}
				footer={
					<AiPredictionFooter text={t('Continue without meal')} onAgree={onAgree} onDisagree={onDisagree} />
				}
			/>
		</>
	);
};

export default AiPurchasePredictionMeal;
